import { render, staticRenderFns } from "./EditFacultyModal.vue?vue&type=template&id=1b3973c6&scoped=true"
import script from "./EditFacultyModal.vue?vue&type=script&lang=js"
export * from "./EditFacultyModal.vue?vue&type=script&lang=js"
import style0 from "./EditFacultyModal.vue?vue&type=style&index=0&id=1b3973c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b3973c6",
  null
  
)

export default component.exports